(function ($) {
    'use strict';

    jQuery(document).ready(function ($) {
        var $chiffres = $('.bloc_chiffres .chiffre > strong > .c');
        if (!$chiffres.length) return;

        var COUNT_DURATION = 1500;

        $chiffres.each(function () {
            var $el = $(this);
            var raw = $.trim($el.text());
            var normalized = raw.replace(/\s/g, '').replace(',', '.');
            var target = parseFloat(normalized);

            if (isNaN(target)) {
                $el.data('skipCount', true);
                return;
            }

            var decimals = 0;
            var dotIdx = normalized.indexOf('.');
            if (dotIdx !== -1) decimals = normalized.length - dotIdx - 1;

            var separator = raw.indexOf(',') !== -1 ? ',' : '.';

            $el.data('targetValue', target);
            $el.data('decimals', decimals);
            $el.data('separator', separator);
            $el.text(formatValue(0, decimals, separator));
        });

        function formatValue(val, decimals, separator) {
            var str = val.toFixed(decimals);
            if (separator === ',') str = str.replace('.', ',');
            return str;
        }

        function isInView($el) {
            var rect = $el[0].getBoundingClientRect();
            var triggerLine = window.innerHeight * 0.85;
            return rect.top < triggerLine && rect.bottom > 0;
        }

        function animateChiffre($el) {
            var target = $el.data('targetValue');
            var decimals = $el.data('decimals');
            var separator = $el.data('separator');

            if (target === null || target === undefined) return;

            $el.addClass('is-counting');

            $({val: 0}).animate({val: target}, {
                duration: COUNT_DURATION,
                easing: 'swing',
                step: function () {
                    $el.text(formatValue(this.val, decimals, separator));
                },
                complete: function () {
                    $el.text(formatValue(target, decimals, separator));
                    $el.removeClass('is-counting');
                }
            });
        }

        function checkChiffres() {
            $chiffres.not('.is-visible').each(function () {
                var $el = $(this);
                if ($el.data('skipCount')) {
                    $el.addClass('is-visible');
                    return;
                }
                if (isInView($el)) {
                    $el.addClass('is-visible');
                    animateChiffre($el);
                }
            });
        }

        var ticking = false;
        $(window).on('scroll resize', function () {
            if (!ticking) {
                window.requestAnimationFrame(function () {
                    checkChiffres();
                    ticking = false;
                });
                ticking = true;
            }
        });

        checkChiffres();
    });

})(jQuery);
